<template>
  <transition mode="out-in" name="slide-fade" appear>
    <h4 class="d-inline-block">
      <span>{{ showStockName ? "Searching " : "Search " }}</span>
      for
      <span>{{
        showStockName ? stockInput.toUpperCase() + "'s" : "Stock's"
      }}</span>
      Details
    </h4>
  </transition>
  <div>
    <transition mode="out-in" name="pop" appear>
      <button
        v-if="!isDev"
        class="btn btn-secondary mb-2 w-100"
        @click="setIsDevState"
      >
        <i class="bi bi-code-slash"></i> &nbsp;<strong>For Developers</strong>
      </button>
      <button
        v-else
        class="btn btn-secondary mb-2 w-100"
        @click="setIsDevState"
      >
        <i class="bi bi-search"></i> &nbsp;<strong>Back to Web Search</strong>
      </button>
    </transition>
  </div>
  <form @submit.prevent>
    <div>
      <transition mode="out-in" name="pop" appear>
        <select
          v-if="isDev"
          class="form-control form-select mb-2"
          required
          v-model="selectExchange"
          @change="formValidity"
        >
          <option selected disabled value="$">Choose Stock Exchange...</option>
          <option value="">US - NASDAQ [eg: MSFT or AAPL]</option>
          <option value=".MY">MY - KLSE [eg: 4715 or 4162]</option>
          <option value=".SG">SG - SGX [eg: Z74 or D05]</option>
        </select>
        <select
          v-else
          class="form-control form-select mb-2"
          required
          v-model="selectExchange"
          @change="formValidity"
        >
          <option selected disabled value="$">Choose Stock Exchange...</option>
          <option value=".nasdaqusa">US - NYSE, NASDAQ, OTC</option>
          <option value=".sgxsingapore">SG - SGX</option>
          <option value=".klsemalaysia">MY - KLSE</option>
        </select>
      </transition>
      <transition mode="out-in" name="pop" appear>
        <input
          v-if="isDev"
          class="form-control security-key mb-2"
          placeholder="Enter API Key here..."
          type="text"
          v-model.trim="securityKey"
          @change="formValidity"
        />
      </transition>
      <div class="input-group">
        <transition mode="out-in" name="pop" appear>
          <input
            v-if="isDev"
            class="form-control"
            placeholder="Search using stock quotes only..."
            type="search"
            v-model.trim="stockInput"
            @change="formValidity"
          />
          <input
            v-else
            class="form-control"
            placeholder="Search stock name or quote..."
            type="search"
            v-model.trim="stockInput"
            @change="formValidity"
          />
        </transition>
        <transition mode="out-in" name="pop" appear>
          <button
            v-if="isDev"
            type="submit"
            class="btn btn-secondary"
            @click="navigateURL"
          >
            <span><i class="bi bi-search"></i></span>
          </button>
          <button
            v-else
            type="submit"
            class="btn btn-secondary"
            @click="navigateURL"
          >
            <span><i class="bi bi-search"></i></span>
          </button>
        </transition>
      </div>
      <div>
        <p class="form-validation-alert mb-0 mt-2" v-if="!formIsValid">
          <span v-if="!this.stockExchangeValidity">Choose Stock Exchange</span>
          <span v-if="!this.secKeyValidity">Key in your API Key</span>
          <span v-if="!this.stockQuoteValidity">Key in the Stock Quote</span>
          and proceed!
        </p>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      showStockName: false,
      stockInput: "",
      selectExchange: "$",
      securityKey: "",
      formIsValid: true,
      stockExchangeValidity: true,
      secKeyValidity: true,
      stockQuoteValidity: true,
      URL: "",
      url1: "https://blush-beaver-tam.cyclic.app/dividend",
      url2: "https://dead-gray-cricket-kit.cyclic.app/search",
    };
  },
  computed: {
    isDev() {
      return this.$store.getters.checkIsDev;
    },
  },
  methods: {
    formValidity() {
      if (
        this.selectExchange === "$" ||
        this.selectExchange === null ||
        this.selectExchange === undefined
      ) {
        this.stockExchangeValidity = false;
      } else {
        this.stockExchangeValidity = true;
      }

      if (
        this.stockInput === "" ||
        this.stockInput === null ||
        this.stockInput === undefined
      ) {
        this.stockQuoteValidity = false;
        this.showStockName = false;
      } else {
        this.stockQuoteValidity = true;
        this.showStockName = true;
      }

      if (
        this.securityKey === "" ||
        this.securityKey === null ||
        this.securityKey === undefined
      ) {
        this.secKeyValidity = false;
        this.$store.dispatch("openAlert", false);
      } else {
        this.secKeyValidity = true;
        this.$store.dispatch("openAlert", true);
      }

      if (this.isDev) {
        if (
          !this.stockExchangeValidity ||
          !this.stockQuoteValidity ||
          !this.secKeyValidity
        ) {
          this.formIsValid = false;
        } else {
          this.formIsValid = true;
        }
      } else {
        this.secKeyValidity = true;
        if (!this.stockExchangeValidity || !this.stockQuoteValidity) {
          this.formIsValid = false;
        } else {
          this.formIsValid = true;
        }
      }
    },
    setIsDevState() {
      this.$store.dispatch("switchSearchMode");
      this.formIsValid = true;
      this.showStockName = false;
      this.stockInput = "";
      this.selectExchange = "$";
      this.securityKey = "";
      this.formValidity();
    },
    navigateURL() {
      this.formValidity();
      if (this.$store.getters.checkIsDev) {
        if (this.formIsValid) {
          return (window.location.href = `${this.url1}/${this.securityKey}/${
            this.stockInput + this.selectExchange
          }`);
        }
      }
      if (!this.$store.getters.checkIsDev) {
        if (this.formIsValid) {
          this.URL = `${this.url2}/${
            this.stockInput.toLowerCase() + this.selectExchange.toLowerCase()
          }`;
          this.$store.dispatch("loadData", {
            url: this.URL,
            stockName: this.stockInput.toUpperCase(),
          });
          return this.$emit("submit-form");
        }
      }
    },
  },
};
</script>

<style scoped>
.form-validation-alert {
  color: #ccc;
}

.light .form-validation-alert {
  color: #333;
}

.form-validation-alert span::after {
  content: ", ";
}
.form-validation-alert span:last-child::after {
  content: "";
}
</style>
